import './usp-slider.scss';

class UspSlider {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-uspslider',
            contentAttr: 'content',
            productAttr: 'product',
            activeClassname: 'usp-slider__product--active'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$uspSlider = $element;
        this.$uspSliderContents = this.$uspSlider.querySelectorAll(`[${this.settings.initAttr}="${this.settings.contentAttr}"]`);

        if (this.$uspSliderContents.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$uspSlider.addEventListener('click', (e) => {
            const $target = e.target.closest(`[${this.settings.initAttr}="${this.settings.productAttr}"]`);
            if ($target) {
                this.setActiveProduct($target);
                e.preventDefault();
            }
        });
    }

    setActiveProduct ($product) {
        const $targetContent = $product.closest(`[${this.settings.initAttr}="${this.settings.contentAttr}"]`);

        this.$uspSliderContents.forEach($content => {
            if ($content !== $targetContent) {
                $content.classList.remove(this.settings.activeClassname);
            }
        });
        $targetContent.classList.add(this.settings.activeClassname);
    }
}

export { UspSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$uspSlider = $context.querySelectorAll('[data-uspslider="root"]');
        for (let i = 0; i < $$uspSlider.length; i++) {
            const $uspSlider = $$uspSlider[i];

            const uspSliderAPI = new UspSlider($uspSlider);
            $uspSlider.API = uspSliderAPI;
        }
    }
});
